import BaseShopLayout from "@shop/components/BaseShopLayout";
import ConsultingSelection from "@shop/components/ConsultingSelection";

const ConsultingShopPage = () => {
    return (
        <BaseShopLayout
            title={"Hier findest Du unser Consulting-Angebot – individuell und praxisnah."}
            description={
                "Ob maßgeschneiderte Workshops, doppelte Wesentlichkeitsanalyse oder persönliche Beratung zu ESG, KI und Immobilien: Wir unterstützen Dich bei Bedarf mit fundiertem Know-how und breiter Expertise. Einfach anfragen – wir melden uns bei Dir."
            }
            buttonLable={"Anfragen"}
            buttonOnClick={() => window.open("https://esgbot.de/kontakt", "_blank", "noopener,noreferrer")}
            buttonDisabled={false}
            useOuterScroll
        >
            <ConsultingSelection />
        </BaseShopLayout>
    );
};

export default ConsultingShopPage;
